import { onBeforeUnmount, onMounted, onUnmounted, ref } from 'vue'
import { CDN } from '../cdn/cdn'

export const useDataRefresh = (interval, widgetId) => {
  // Check CDN URL and log the message if the condition matches
  const cdnUrl = CDN.getCdnUrl()
  const isDEV = cdnUrl.includes('green') || cdnUrl.includes('localhost')

  const cacheKey = 'SportsMode_DRF_Interval'

  let injectedInterval = ''

  if (isDEV) {
    injectedInterval = localStorage.getItem(cacheKey)
  }
  const adjustedInterval = injectedInterval || interval
  const intervalId = ref(null)
  const shouldCallApiRef = ref(false)

  const startRefresh = (refreshFn, shouldCallApi = () => false, shouldStopRefresh = () => false, getIsPaused = () => false) => {
    shouldCallApiRef.value = shouldCallApi()

    if (isDEV) logOnMock(shouldCallApiRef.value ? 'active' : 'inactive')

    intervalId.value = setInterval(async () => {
      const isThereDrfContainer = document.querySelector(`[drf-id=${widgetId}]`)

      if (!isThereDrfContainer || shouldStopRefresh()) {
        // no drf container || failed 10 times
        stopRefresh()
      } else if (!getIsPaused()) {
        shouldCallApiRef.value && (await refreshFn())
      } else {
        // smth wrong, stopRefresh
        stopRefresh()
      }
    }, adjustedInterval)
  }

  const stopRefresh = () => {
    if (intervalId.value) {
      clearInterval(intervalId.value)
      intervalId.value = null
      if (isDEV) logOnMock('inactive')
    }
  }

  const logOnMock = status => window.SportsMode?.setDRFStatus?.(status, adjustedInterval)

  // Automatically clear interval when the widget is unmounted/reloaded
  onUnmounted(stopRefresh)
  onBeforeUnmount(stopRefresh) // Ensures it runs in Vue's lifecycle

  // Listen for page reload and clear the interval
  onMounted(() => {
    window.addEventListener('beforeunload', stopRefresh)
  })

  onUnmounted(() => {
    window.removeEventListener('beforeunload', stopRefresh)
  })

  return {
    interval,
    startRefresh,
    stopRefresh
  }
}
